import { DataGrid } from '@material-ui/data-grid';
import React, { useEffect, useState } from 'react';
import { configs } from '../../../assets/Config';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import LeftBarPage from '../../includes/dashboard/LeftBarPage';
import TopBarPage from '../../includes/dashboard/TopBarPage';
import '../../../assets/styles/NM.css'
import { useNMContext } from '../../../services/contexts/NMContext';
import ToastPage from '../../includes/ToastPage';
import { Link } from 'react-router-dom';
import { useHistory, useParams } from 'react-router';
import { getScheduleEmailBroadcast, schedulerUpdateTemplate } from '../../../services/apis/notificationManagement/NMAPI';

export default function WhatsAppTemplatePage() {

    const { whatsappTemplate, setWhatsappTemplate, getWhatsappTemplateById, updateWhatsappTemplateById, templateId, setTemplateId } = useNMContext()
    const { setCurrModule, setShowSuccess, allowedFunc, token, logout, setLoginError } = useLogin()

    const [template, setTemplate] = useState("")
    const [headVariable, setHeadVariable] = useState("")
    const [bodyVariable, setBodyVariable] = useState("")
    const [error, setError] = useState("")

    const history = useHistory()

    const { id } = useParams()

    useEffect(() => {
        setTemplateId(id)
    }, [])

    useEffect(() => {
        // if (templateId) {
        try {
            setCurrModule(configs.modules.mnt)
            if (allowedFunc.includes(configs.functionList['notification_management:notification_management'])) {
                (async () => {
                    if (whatsappTemplate.scheduler_id) {
                        let response = await getScheduleEmailBroadcast(token, null, whatsappTemplate.scheduler_id)
                        if (response && response.status === 200) {
                            setWhatsappTemplate({ ...whatsappTemplate, ...response.data.data.template_data })
                            setTemplateId(response.data.data.template_data.template_id)
                        } else if (response && response.status === 401) {
                            logout();
                            setLoginError(configs.unauthorizedErrorMessage);
                        } else {
                            setError(response.data.error)
                        }
                    }

                    if (templateId) {
                        await getWhatsappTemplateById(whatsappTemplate.scheduler_id)
                    }
                })()
            } else {
                return history.goBack()
            }
        } catch (error) {

        }
        // }
    }, [templateId, whatsappTemplate.scheduler_id])

    useEffect(() => {
        try {
            setTemplate(whatsappTemplate.template_name || whatsappTemplate.whatsapp_template_name)
            setHeadVariable(whatsappTemplate.head_variable || whatsappTemplate.whatsapp_head_variable)
            setBodyVariable(whatsappTemplate.body_variable || whatsappTemplate.whatsapp_body_variable)
        } catch (error) {

        }
    }, [whatsappTemplate])


    // update mobile template
    async function updateTemplate() {
        try {
            document.getElementById("whatsappBtn").classList.toggle("d-none")
            document.getElementById("whatsappBtnLoader").classList.toggle("d-none")

            if (!template.trim()) {
                setError("Please provide a valid Template Name")
            } else {
                if (whatsappTemplate.scheduler_id) {
                    let response = await schedulerUpdateTemplate(token, whatsappTemplate)
                    if (response && response.status === 200) {
                        setShowSuccess(true)
                        history.goBack();
                    } else if (response && response.status === 401) {
                        logout();
                        setLoginError(configs.unauthorizedErrorMessage);
                    } else {
                        setError(response.data.error)
                    }
                } else {
                    let response = await updateWhatsappTemplateById(template, headVariable, bodyVariable)
                    if (response === "success") {
                        setShowSuccess(true)
                    } else {
                        setError(response)
                    }
                }
            }

            document.getElementById("whatsappBtn").classList.toggle("d-none")
            document.getElementById("whatsappBtnLoader").classList.toggle("d-none")
        } catch (error) {
            console.error(error);
        }
    }


    // notification management main ui code
    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                <div id='nmMobContainer' className="nm-container">
                    <div style={{ width: "100%" }}>
                        <div className="row d-flex align-items-center mt-2 ml-2 mb-2 mr-3">
                            <div className="col-md-9 text-left">
                                <p className="h4 text-custom-grey">WhatsApp Notification Template - {whatsappTemplate.name}</p>
                                <p>{whatsappTemplate.description}</p>
                            </div>
                            <div className="col-md-3 text-left text-md-right">
                                <Link to="/notificationTemplateManagement"><i className="fas fa-id-card-alt mr-2"></i>Manage Templates</Link>
                            </div>
                        </div>
                        {whatsappTemplate ?
                            <div className="mt-2 mb-4 mr-4 nm-template">
                                <p className="text-primary h6 my-4">WhatsApp Template Variables</p>
                                <div className="row pl-3">
                                    {whatsappTemplate.variables ?
                                        whatsappTemplate.variables.map((element, key) => {
                                            return (
                                                <div key={`whatsappTemplate` + key} className="row d-flex align-items-center justify-content-center variable-card ml-2">
                                                    <div className="col-10">
                                                        <p className="text-custom-grey p-0 m-0">{element.name} ({element.symbol})</p>
                                                    </div>
                                                    <div className="col-2 text-right">
                                                        <a href="#" onClick={(e) => {
                                                            e.preventDefault()
                                                            navigator.clipboard.writeText(element.symbol);
                                                        }}><i className="far fa-copy text-primary cursor" ></i></a>
                                                    </div>
                                                </div>

                                            )
                                        })

                                        : null}
                                </div>
                                <p className="text-primary h6 mt-5 pl-0 ml-0">WhatsApp Template Admins</p>
                                <div className="pr-3">
                                    <form action="">

                                        <div className="form-group">
                                            <label htmlFor="whatsapp_body">Template Name</label>
                                            <input type="text" className="form-control" value={template ? template : ""} onChange={(e) => {
                                                if (whatsappTemplate.scheduler_id) {
                                                    setWhatsappTemplate({ ...whatsappTemplate, ...{ whatsapp_template_name: e.target.value } })
                                                }
                                                setTemplate(e.target.value)
                                            }}></input>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="whatsapp_body">Head Variable</label>
                                            <input type="text" className="form-control" value={headVariable ? headVariable : ""} onChange={(e) => {
                                                if (whatsappTemplate.scheduler_id) {
                                                    setWhatsappTemplate({ ...whatsappTemplate, ...{ whatsapp_head_variable: e.target.value } })
                                                }
                                                setHeadVariable(e.target.value)
                                            }}></input>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="whatsapp_body">Body Variable</label>
                                            <input type="text" className="form-control" value={bodyVariable ? bodyVariable : ""} onChange={(e) => {
                                                if (whatsappTemplate.scheduler_id) {
                                                    setWhatsappTemplate({ ...whatsappTemplate, ...{ whatsapp_body_variable: e.target.value } })
                                                }
                                                setBodyVariable(e.target.value)
                                            }}></input>
                                        </div>
                                        <div className="form-check p-0">
                                            <p className="text-danger" id="templateError">{error}</p>
                                        </div>
                                        <div className="form-row">
                                            <div className="col-12 d-flex justify-content-center">
                                                <button id="whatsappBtn" type="submit" className="btn btn-primary" onClick={(e) => {
                                                    e.preventDefault()
                                                    updateTemplate()
                                                }}>Update Template</button>
                                                <div id="whatsappBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                                                {templateId === 86 ?
                                                    <>
                                                        <button id="sendBtn" type="submit" className="btn btn-primary ml-2" onClick={(e) => {
                                                            e.preventDefault()
                                                            updateTemplate()
                                                        }}>Send Notification</button>
                                                        <div id="sendBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                                                    </>
                                                    : null}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            : <div className="loader"></div>}
                    </div>
                </div>
                <ToastPage />
            </div>
        </>
    )
}